import React, { Suspense } from 'react';
import './index.css';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { SidebarProvider } from 'context/SidebarContext';
import 'react-datepicker/dist/react-datepicker.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { NotificationProvider } from 'context/NotificationContext';
import { createRoot } from 'react-dom/client';
import SplashScreen from 'components/SplashScreen';
import { ThemeProvider } from 'context/ThemeContext';
const container = document.getElementById('root');
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
  <Suspense fallback={<SplashScreen />}>
    <SidebarProvider>
      <NotificationProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </NotificationProvider>
    </SidebarProvider>
  </Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
